import styled from 'styled-components';

export default styled.div`
  position: relative;

  font-family: 'Sanko';

  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #282c34;
  min-height: 100vh;
  height: 100vh;
  max-height: 100vh;
  color: white;
  font-size: 5rem;
`;
